const projects = [
  {
    id: 1,
    image: '/images/projects/1.jpg',
    name: 'Support exchange students in Munich as a host family',
    organization: 'Partnership International E.V',
    duration: 'Mar 01 - May 31',
    days: 'Mon, Wed, Fri',
    time: '17:00 - 18:00',
    place: 'Naumannstr. 4/5, 93442 Melle',
    content:
      'The exchange students are an integral part of the family for the duration of their stay and should be actively involved in family life, including all the responsibilities that go with it. The student will therefore be a new part of your everyday life.',
    volunteers: '8/15',
    skills: 'Language, Conversational Skill, Physical Work',
    contact_person: 'Ulla Burchardt',
    contact_email: 'ulla.burchardt@partnership.org',
  },
  {
    id: 2,
    image: '/images/projects/2.jpg',
    name: 'Support the football friday for refugee young people',
    organization: 'Utopia Freizeitstätte',
    duration: '',
    days: ' Fri',
    time: '17:00 - 19:00',
    place: 'chreibergasse 1/0, 52630 Dessau',
    content:
      'During the football matches you are always a contact person for the boys. You support Leo in explaining the procedure and the rules of the game to the participants, distributing and collecting equipment. The available 90 minutes are mostly in mini tournament form. Your task is to take notes of the results on the tournament schedule during the mostly quite hectic games and to keep an eye on the overall situation.',
    volunteers: '2/6',
    skills: 'Language, Physical Work',
    contact_person: 'Jens Ackermann',
    contact_email: 'jens.ackermann@utopia.org',
  },
  {
    id: 3,
    image: '/images/projects/3.jpg',
    name: 'Supervise children and youth campus',
    organization: 'Fahrten-ferne-abenteuer Ferienwerk Ggmbh',
    duration: 'Apri 01 - Aug 31',
    days: '',
    time: '',
    place: 'Bernard-Heß-Weg 07, 01899 Cottbus',
    content:
      'After the preparation seminar you can freely arrange and plan your leisure time program. During your free time you will be responsible for running the programme, preparing meals, managing the ticket office and looking after the children. Accommodation and transportation will be booked in advance by the office team, so this is not your responsibility.',
    volunteers: '3/10',
    skills: 'Film & Photography, Conversational Skill, Language',
    contact_person: 'Christian Ahrendt',
    contact_email: 'christian.ahrendt@fahrtenferne.org',
  },
  {
    id: 4,
    image: '/images/projects/4.jpg',
    name: 'Support young refugees as a mentor',
    organization: 'Gemeinschaftsunterkunft Für Geflüchtete Marzah',
    duration: 'Apr 01 - Jun 31',
    days: 'Mon, Wed, Fri',
    time: '17:00 - 18:00',
    place: 'Remote Volunteering',
    content:
      'Help children with their homework. Answer school-related questions. Support young adolescents in their search for an internship or further education. Train computer skills (Microsoft Office, soft skills such as surfing the internet)',
    volunteers: '12/20',
    skills: 'Language, Conversational Skill, PC Skills',
    contact_person: 'Agnes Alpers',
    contact_email: 'agnes.alpers@gemeinscharf.org',
  },
  {
    id: 5,
    image: '/images/projects/5.jpg',
    name: 'Support refugees with german Tandem',
    organization: 'Deutsch-türkisches Forum Stuttgart E.V.',
    duration: 'Apr 01 - Jun 31',
    days: 'Mon, Thu',
    time: '18:00 - 20:00',
    place: 'Kriegergasse 58, 01262 Hildburghausen',
    content:
      'We would like to start our language café LISAN. For this volunteer work, you should have experience in the area of German as a foreign language and enjoy speaking. Pedagogical knowledge would also be very important.',
    volunteers: '4/16',
    skills: 'Language, Conversational Skill',
    contact_person: 'Peter Altmaier',
    contact_email: 'peter.altmaier@forum-stuttgart.org',
  },
  {
    id: 6,
    image: '/images/projects/6.jpg',
    name: 'Support homeless people with food distribution ',
    organization: 'Junges Engagement Charlottenburg-wilmersdorf',
    duration: 'Mar 01 - May 31',
    days: 'All days',
    time: '11:00 - 13:00',
    place: 'Melanie-Beck-Weg 6, 67046 Bergzabern',
    content:
      'With our offer YOUNG COMMITMENT we give young people between 14 and 27 years of age a variety of opportunities to experience co-determination and participation in their neighbourhood. Dealing with socially relevant issues and strengthening democracy are important goals that we promote together with those who are voluntarily engaged.',
    volunteers: '1/12',
    skills: 'Cooking, Physical Work',
    contact_person: 'Rainer Arnold',
    contact_email: 'rainer.arnold@junges.org',
  },
];

export default projects;
